<div class="pos-relative">
  <div class="keno-grid-container">
    <particle-virtual-grid (columnHeaderButtonClicked)="onColumnHeaderButtonClicked($event)"
                           (selectionChanged)="onSelectionChanged($event)"
                           (valueChanged)="onGridCellValueChange($event)"
                           [api]="api"
                           [invalidateSubject]="invalidateSubject"
                           [parameters]="data?.input"
                           [sourceKey]="sourceType"
                           tabStyle="compact"
                           version="v2">
    </particle-virtual-grid>
  </div>
</div>
